<template>
  <v-card v-if="enabled" outlined class="pa-4">
    <div class="text-subtitle-1 font-weight-bold">
      Coincidencias en leads existentes
    </div>
    <p class="caption grey--text text--darken-1 mb-3">
      Etiqueta los leads que ya estaban en la base y coinciden por teléfono o
      correo. No vincula nada: la vinculación se hace después, lead por lead,
      desde el botón Coincidencias.
    </p>
    <v-btn color="primary" small :loading="loading" @click="dialog = true">
      Etiquetar coincidencias
    </v-btn>
    <v-alert v-if="result" type="success" text dense class="mt-3 mb-0">{{
      result
    }}</v-alert>
    <v-alert v-if="error" type="error" text dense class="mt-3 mb-0">{{
      error
    }}</v-alert>

    <v-dialog v-model="dialog" max-width="440">
      <v-card>
        <v-card-title class="text-h6">Etiquetar coincidencias</v-card-title>
        <v-card-text>
          Se revisarán todos los leads existentes de la inmobiliaria. Puede
          tardar si hay muchos.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="run">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { LabelExistingMatches } from "@/api/lead-api.js";

export default {
  name: "LabelExistingMatches",
  data() {
    return { dialog: false, loading: false, result: "", error: "" };
  },
  computed: {
    // solo para root/admin y con la agrupación activa
    enabled() {
      const group = this.$store.state.realEstateGroup?.realEstateGroup;
      const role = localStorage.getItem("user_role");
      return (
        ["root", "admin"].includes(role) &&
        !!group &&
        group.contact_grouping === "on"
      );
    }
  },
  methods: {
    async run() {
      this.dialog = false;
      this.loading = true;
      this.result = "";
      this.error = "";
      try {
        const res = await LabelExistingMatches();
        this.result = `Leads etiquetados: ${res.labeled}`;
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
